export const AUTO_SSO_ATTEMPT_KEY = "margin-risk:auto-sso-attempted";

export function beginAutoSsoAttempt(storage) {
  if (storage.getItem(AUTO_SSO_ATTEMPT_KEY) === "1") return false;
  storage.setItem(AUTO_SSO_ATTEMPT_KEY, "1");
  return true;
}

export function clearAutoSsoAttempt(storage) {
  storage.removeItem(AUTO_SSO_ATTEMPT_KEY);
}
